import { useEffect, useState } from "react";

import Grid from "@mui/material/Grid"
import Button from "@mui/material/Button";
import OutlinedInput from "@mui/material/OutlinedInput";

export default function CalendarYearInput({calendarYear: calendarYear, setCalendarYear: setCalendarYear}) {
  const [calendarYearInputValue, setCalendarYearInputValue] = useState(calendarYear);

  useEffect(() => setCalendarYearInputValue(calendarYear), [calendarYear]);

  const handleChangeCalendarYear = (event) => {
    setCalendarYearInputValue(event.target.value);
  }

  const handleBlurCalendarYear = (event) => {
    let year = event.target.value.replaceAll(/[^0-9]/g, "");
    setCalendarYear(parseInt(year));
    setCalendarYearInputValue(year);
  }

  const onClickPreviousYear = (event) => {
    setCalendarYear(calendarYear - 1);
  }

  const onClickNextYear = (event) => {
    setCalendarYear(calendarYear + 1);
  }
  
  return (
    <Grid container alignItems="center" spacing={1}>
      <Grid item xs="auto">
        <OutlinedInput
          onFocus={(event) => event.target.select()}
          onChange={handleChangeCalendarYear}
          onBlur={handleBlurCalendarYear}
          value={calendarYearInputValue}
        /> 年 
      </Grid>
      <Grid item xs="auto">
        <Button variant="contained" onClick={onClickPreviousYear}>前年</Button>
      </Grid>
      <Grid item xs="auto">
        <Button variant="contained" onClick={onClickNextYear}>次年</Button>
      </Grid>
    </Grid>
  );
}
